module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "alfred-pritz-square.27e5e74a.png" + "?" + Date.now();